import { useState, useEffect } from "react";
import { BackToTopButton } from "./to-top-button.styles";
import { ReactComponent as ToUp } from "../../assets/arrow-up.svg";

function ToTopButton() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  // This function will scroll the window to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smoothly scrolling
    });
  };

  return (
    <>
      <BackToTopButton onClick={scrollToTop} show={showButton}>
        <ToUp />
      </BackToTopButton>
    </>
  );
}

export default ToTopButton;
